import React from "react"
import UAI from "../UAI"
import Atributo from "../Utils/Atributo"
import { FiAlertTriangle } from "react-icons/fi"
import styles from "../Utils/Styles"
import StatCohorte from "../Stats/StatCohorte"
import log from "loglevel"

/**
 * Verifica si el usuario tiene permiso para revisar cifras de venta
 * @param {Object} usuario
 * @returns
 */
const tienePermisoCifrasVenta = (usuario) => {
  let tienePermiso =
    usuario.esadministrador ||
    usuario.roles.indexOf("Director de Ventas") >= 0 ||
    usuario.roles.indexOf("Director Ejecutivo Postgrados") >= 0 ||
    usuario.roles.indexOf("Finanzas") >= 0
  return tienePermiso
}

/**
 * Devuelve el par meta, cumplimiento para el mes actual
 * @param {Object} cohorte
 * @param {Object} stat
 * @param {boolean} total verdadero si usamos el total
 * @returns
 */
const metaCumplimiento = (cohorte, stat, total = undefined) => {
  // Obtenemos la meta actual
  let metaActual = UAI.obtieneMetaActualCohorte(cohorte)
  let metaTotal = UAI.obtieneMetaTotalCohorte(cohorte)
  // Si no exista meta o no tenemos estadísticas retornamos vacío
  if (!metaActual || !metaActual[stat] || !metaTotal || !metaTotal[stat]) {
    if (!metaTotal && metaActual) {
      log.debug(metaActual)
      log.debug(metaTotal)
    }
    if (total) {
      let output = [null, null, null, null]
      if (metaTotal && metaTotal[stat]) {
        output[2] = parseFloat(
          metaTotal[stat].toFixed(1).toString().slice(-1) === "0"
            ? metaTotal[stat].toFixed(0)
            : metaTotal[stat].toFixed(1)
        )
        output[3] =
          (metaTotal[stat] > 0
            ? ((cohorte.Stats[stat] / metaTotal[stat]) * 100).toFixed(0)
            : 0) + "%"
      }
      if (metaActual && metaActual[stat]) {
        output[0] = parseFloat(
          metaActual[stat].toFixed(1).toString().slice(-1) === "0"
            ? metaActual[stat].toFixed(0)
            : metaActual[stat].toFixed(1)
        )
        output[1] =
          (metaActual[stat] > 0
            ? ((cohorte.Stats[stat] / metaActual[stat]) * 100).toFixed(0)
            : 0) + "%"
      }
      return output
    } else {
      return [null, null]
    }
  }
  if (total) {
    // Retornamos meta sin decimales si es entero
    return [
      parseFloat(
        metaActual[stat].toFixed(1).toString().slice(-1) === "0"
          ? metaActual[stat].toFixed(0)
          : metaActual[stat].toFixed(1)
      ),
      (metaActual[stat] > 0
        ? ((cohorte.Stats[stat] / metaActual[stat]) * 100).toFixed(0)
        : 0) + "%",
      parseFloat(
        metaTotal[stat].toFixed(1).toString().slice(-1) === "0"
          ? metaTotal[stat].toFixed(0)
          : metaTotal[stat].toFixed(1)
      ),
      (metaTotal[stat] > 0
        ? ((cohorte.Stats[stat] / metaTotal[stat]) * 100).toFixed(0)
        : 0) + "%",
    ]
  }
  // Retornamos meta sin decimales si es entero
  return [
    metaActual[stat].toFixed(1).toString().slice(-1) === "0"
      ? metaActual[stat].toFixed(0)
      : metaActual[stat].toFixed(1),
    (metaActual[stat] > 0
      ? ((cohorte.Stats[stat] / metaActual[stat]) * 100).toFixed(0)
      : 0) + "%",
  ]
}

/**
 * Mostramos el cumplimiento total para un stat en particular
 * @param {Object} stat
 * @param {String} statkey
 * @returns
 */
const totalCumplimiento = (stat, statkey, total = undefined) => {
  // Si tenemos stats y meta mostramos porcentaje, de otra forma 0
  stat.Stats["Cumplimiento" + statkey] =
    stat.Stats["Meta" + statkey] > 0
      ? ((stat.Stats[statkey] / stat.Stats["Meta" + statkey]) * 100).toFixed(0)
      : 0
  stat.Stats["CumplimientoTotal" + statkey] =
    stat.Stats["MetaTotal" + statkey] > 0
      ? (
          (stat.Stats[statkey] / stat.Stats["MetaTotal" + statkey]) *
          100
        ).toFixed(0)
      : 0

  if (total) {
    return [
      <StatCohorte
        stat={stat.Stats}
        name={"Meta" + statkey}
        Total
        SinDecimales
      />,
      <StatCohorte
        stat={stat.Stats}
        name={"Cumplimiento" + statkey}
        Total
        SinDecimales
      />,
      <StatCohorte
        stat={stat.Stats}
        name={"MetaTotal" + statkey}
        Total
        SinDecimales
      />,
      <StatCohorte
        stat={stat.Stats}
        name={"CumplimientoTotal" + statkey}
        Total
        SinDecimales
      />,
    ]
  }

  return [
    <StatCohorte
      stat={stat.Stats}
      name={"Meta" + statkey}
      Total
      SinDecimales
    />,
    <StatCohorte
      stat={stat.Stats}
      name={"Cumplimiento" + statkey}
      Total
      SinDecimales
    />,
  ]
}

const columns = {
  fechainicio: {
    key: "fechainicio",
    title: "Inicio",
    titleshort: "Ini",
    headeronly: true,
    periodos: (usuario) => [usuario.periodo],
    content: (cohorte, usuario) => [
      <>
        {cohorte.FechaInicioString}
        <Atributo field={usuario.atributos["habilitado"]} cohorte={cohorte} />
        <Atributo
          field={usuario.atributos["disponibilidad"]}
          cohorte={cohorte}
        />
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.FechaInicioString]
    },
    className: (cohorte) => "FechaInicio",
    nototal: true,
  },
  visitantes: {
    key: "visitantes",
    title: "Visitantes",
    titleshort: "Vis",
    periodos: (usuario) => [usuario.periodo],
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && cohorte.mostrarVisitantes && (
          <StatCohorte
            stat={cohorte.Stats}
            name="Visitantes"
            SinDecimales
            title={"Visitas al sitio web " + cohorte.nombrecorto}
          />
        )}
        {(!cohorte.Periodo || !cohorte.mostrarVisitantes) && (
          <div
            title={
              "Cohorte no es del período o su página es compartida con otro cohorte (" +
              cohorte.nombrecorto +
              ")"
            }
          >
            &nbsp;
          </div>
        )}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.Visitantes : ""]
    },
  },
  interesados: {
    key: "interesados",
    title: "Interesados",
    titleshort: "Int",
    periodos: (usuario) => [usuario.periodo],
    className: (cohorte) => " Postulantes",
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            title="Interesados en Salesforce: Total / Campañas"
            name="Interesados"
            versus="InteresadosCampañas"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.Interesados : ""]
    },
  },
  centrocosto: {
    key: "centrocosto",
    title: "Centro de costo",
    titleshort: "CC",
    periodos: (usuario) => [usuario.periodo],
    onClick: [],
    content: (cohorte, usuario) => {
      return [<>{cohorte.centrocosto}</>]
    },
    excel: (cohorte, usuario) => {
      if (!cohorte.Periodo) return [null]
      return [cohorte.centrocosto]
    },
  },
  postulantes: {
    key: "postulantes",
    title: "Postulantes",
    statkey: "Postulantes",
    titleshort: "Pos",
    periodos: (usuario) => [usuario.periodo, usuario.periodo - 1],
    compareto: "prev",
    className: (cohorte) => cohorte.css.Postulantes + " Postulantes",
    style: (cohorte) => styles[cohorte.css.Postulantes],
    onClick: [],
    content: (cohorte, usuario) => {
      let benchmarkInvalido =
        cohorte &&
        cohorte.Periodo &&
        cohorte.benchmarkinfo &&
        cohorte.benchmarkinfo.año_inicio !== cohorte.año_inicio - 1
      return [
        <>
          {cohorte.Periodo && (
            <StatCohorte
              stat={cohorte.Stats}
              statprev={cohorte.StatsLw}
              name="Postulantes"
              SinDecimales
            />
          )}
          {!cohorte.Periodo && <div></div>}
        </>,
        <>
          {!cohorte.StatsPrev && !benchmarkInvalido && (
            <Atributo
              cohorte={cohorte}
              field={usuario.atributos["programaid_anterior"]}
              periodo={cohorte.año_inicio}
              //              guardarCambios={guardarCambios}
            />
          )}
          {benchmarkInvalido && (
            <>
              {cohorte.benchmarkinfo.sigla}
              <FiAlertTriangle title="Cohorte benchmark sin datos!" />
            </>
          )}
          {cohorte.StatsPrev && !benchmarkInvalido && (
            <div>{cohorte.StatsPrev.Postulantes}</div>
          )}
        </>,
      ]
    },
    excel: (cohorte, usuario) => {
      if (!cohorte.Periodo) return [null, null]
      return [
        cohorte.Stats ? cohorte.Stats.Postulantes : null,
        cohorte.StatsPrev ? cohorte.StatsPrev.Postulantes : null,
      ]
    },
  },
  porentrevistar: {
    key: "porentrevistar",
    title: "Por entrevistar",
    titleshort: "PE",
    periodos: (usuario) => [usuario.periodo],
    className: (cohorte) => "Postulantes",
    onClick: ["Por Entrevistar"],
    statkey: "PorEntrevistar",
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte stat={cohorte.Stats} name="PorEntrevistar" />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.PorEntrevistar : null]
    },
  },
  aceptados: {
    key: "aceptados",
    title: "Aceptados",
    titleshort: "Ac",
    periodos: (usuario) => [usuario.periodo],
    compareto: "lw",
    className: (cohorte) => "Postulantes",
    onClick: ["Aceptado", "Aceptado Académico"],

    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            statprev={cohorte.StatsLw}
            name="Aceptados"
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.Aceptados : null]
    },
  },
  matriculados: {
    key: "matriculados",
    title: "Matriculados",
    titleshort: "Mat",
    periodos: (usuario) => [usuario.periodo, usuario.periodo - 1],
    compareto: "prev",
    className: (cohorte) => cohorte.css.Matriculados + " Postulantes",
    style: (cohorte) => styles[cohorte.css.Matriculados],
    onClick: ["Matriculado", "Pendiente Firma"],
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            statprev={cohorte.StatsLw}
            name="Matriculados"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.StatsPrev}
            name="Matriculados"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      if (!cohorte.Periodo) return [null, null]
      return [
        cohorte.Stats ? cohorte.Stats.Matriculados : null,
        cohorte.StatsPrev ? cohorte.StatsPrev.Matriculados : null,
      ]
    },
  },
  equivalentesPeriodo: {
    key: "equivalentesperiodo",
    title: "Equivalentes período",
    titleshort: "EqPer",
    periodos: (usuario) => [usuario.periodo],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    statkey: "Equivalentes",
    compareto: "prev",
    className: (cohorte) => "Postulantes",
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            statprev={cohorte.StatsLw}
            name="Equivalentes"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.Equivalentes : null]
    },
  },
  equivalentes: {
    key: "equivalentes",
    title: "Equivalentes",
    titleshort: "Eq",
    periodos: (usuario) => [usuario.periodo, usuario.periodo - 1],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    compareto: "prev",
    className: (cohorte) => cohorte.css.Equivalentes + " Postulantes",

    style: (cohorte) => styles[cohorte.css.Equivalentes],
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            statprev={cohorte.StatsPrev}
            name="Equivalentes"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.StatsPrev}
            name="Equivalentes"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [
        cohorte.Periodo ? cohorte.Stats.Equivalentes : null,
        cohorte.StatsPrev ? cohorte.StatsPrev.Equivalentes : null,
      ]
    },
  },
  metapostulantes: {
    key: "metapostulantes",
    title: "Meta postulantes",
    titleshort: "MP",
    periodos: (usuario) => [
      UAI.meses[new Date().getMonth()].slice(0, 3),
      "Cump",
      "Total",
      "Cump",
    ],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    className: (cohorte) => cohorte.CssMeta + " Postulantes",
    style: (cohorte) => styles[cohorte.CssMeta],
    content: (cohorte, usuario) => {
      return metaCumplimiento(cohorte, "Postulantes", true)
    },
    total: (stat) => {
      return totalCumplimiento(stat, "Postulantes", true)
    },
    excel: (cohorte, usuario) => {
      return metaCumplimiento(cohorte, "Postulantes", true)
    },
  },
  metaequivalentes: {
    key: "metaequivalentes",
    title: "Meta equivalentes",
    titleshort: "ME",
    periodos: (usuario) => [
      UAI.meses[new Date().getMonth()].slice(0, 3),
      "Cump",
      "Total",
      "Cump",
    ],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    className: (cohorte) => cohorte.CssMeta + " Postulantes",
    style: (cohorte) => styles[cohorte.CssMeta],
    content: (cohorte, usuario) => {
      return metaCumplimiento(cohorte, "Equivalentes", true)
    },
    total: (stat) => {
      return totalCumplimiento(stat, "Equivalentes", true)
    },
    excel: (cohorte, usuario) => {
      let valores = metaCumplimiento(cohorte, "Equivalentes", true)
      valores = valores.reduce((prev, current) => {
        if (current && !current.toString().includes("%")) {
          current = parseFloat(current)
        }
        prev.push(current)
        return prev
      }, [])
      return valores
    },
  },
  metamatriculados: {
    key: "metamatriculados",
    title: "Meta matriculados",
    titleshort: "MM",
    statkey: "MetaMatriculados",
    periodos: (usuario) => [
      UAI.meses[new Date().getMonth()].slice(0, 3),
      "Cump",
      "Total",
      "Cump",
    ],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    nototal: false,
    className: (cohorte) => cohorte.CssMeta + " Postulantes",
    style: (cohorte) => styles[cohorte.CssMeta],
    content: (cohorte, usuario) => {
      return metaCumplimiento(cohorte, "Matriculados", true)
    },
    total: (stat) => {
      return totalCumplimiento(stat, "Matriculados", true)
    },
    excel: (cohorte, usuario) => {
      return metaCumplimiento(cohorte, "Matriculados", true)
    },
  },
  ingresos: {
    key: "ingresos",
    title: "Ingresos",
    titleshort: "$(mm)",
    statkey: "VentasCLP",
    periodos: (usuario) => [usuario.periodo],
    filtro: (usuario, cohorte) => {
      return tienePermisoCifrasVenta(usuario)
    },
    compareto: "prev",
    content: (cohorte, usuario) => [
      <>
        {cohorte.Periodo && (
          <StatCohorte
            stat={cohorte.Stats}
            statprev={cohorte.StatsPrev}
            name="VentasCLP"
            SinDecimales
          />
        )}
        {!cohorte.Periodo && <div></div>}
      </>,
    ],
    excel: (cohorte, usuario) => {
      return [cohorte.Periodo ? cohorte.Stats.VentasCLP : null]
    },
  },
}

export default columns
